import React from 'react'
import injectSheet from 'react-jss'

const Home = (props) => {
  const {
    classes,
    home: { background },
  } = props

  return (
    <div className={`${classes.container}`}>
      <div
        className={`${classes.backgroundContainer}`}
        style={{ backgroundImage: `url(${process.env.REACT_APP_BASE_PATH}${background})` }}
      />
    </div>
  )
}

const styles = theme => ({
  container: {
    height: '100vh',
    width: '100vw',
    padding: `${theme.sizes.header}px 0 ${theme.sizes.footerExpanded}px 0`,
    [theme.media.medium]: {
      padding: `${theme.sizes.headerLarge}px 0 ${theme.sizes.footerExpanded}px 0`,
    },
  },
  backgroundContainer: {
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    height: '100%',
    width: '100%',
  },
})

export default injectSheet(styles)(Home)



// WEBPACK FOOTER //
// ./src/modules/core/components/home.jsx